<template>
  <div class="row border-0">
    <div
      :class="containerCol"
      v-for="(deals, index) in data"
    >
      <div class="widget border-0">
        <div class="header border-0">
          <div class="title">
            {{ __(deals.title) }}
          </div>
        </div>
        <div
          class="body mt-4 border-0"
          v-if="loading"
        >
          <span class="loading"><i class="fa fa-circle-o-notch fa-spin border-0" /></span>
        </div>
        <div
          class="body mt-4 border-0"
          v-else
        >
          <div class="deals border-0 d-flex justify-content-center" :id="`${deals.svgId}-container`">
            <svg
              class="d-flex mx-auto"
              :id="`${deals.svgId}-svg`"
              viewbox="0 0 100 100"
              width="165"
              height="165"
              style="margin-left: auto; margin-right: auto; display: flex; font-size: 1rem; line-height: 150%; padding: 0"
              v-if="displaySvg[deals.svgId]"
            >
              <defs>
                <linearGradient :id="'gradient-' + index" >
                  <stop
                    offset="0%"
                    :stop-color="deals.colors[0]"
                  />
                  <stop
                    offset="100%"
                    :stop-color="deals.colors[1]"
                  />
                </linearGradient>
                <filter id="dropShadow">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="1"
                  />
                  <feOffset
                    dx="0"
                    dy="8.2"
                  />
                  <feMerge>
                    <feMergeNode />
                    <feMergeNode in="SourceGraphic" />
                  </feMerge>
                </filter>
              </defs>
              <path
                fill="none"
                stroke-linecap="round"
                stroke-width="8"
                stroke="rgba(165, 131, 224, 0.18)"
                style="filter:url(#dropShadow)"
                d="M 80 4 a 45 45 0 0 1 0 144 a 45 45 0 0 1 0 -144"
              />
              <path
                fill="none"
                stroke-linecap="round"
                stroke-width="8"
                stroke="#D1D1D1"
                d="M 80 4 a 45 45 0 0 1 0 144 a 45 45 0 0 1 0 -144"
              />
              <path
                fill="none"
                stroke-linecap="round"
                stroke-width="8"
                :stroke="getStroke(index)"
                :stroke-dasharray="4.444 * deals.percent[1] + ',444.4'"
                d="M 80 4 a 45 45 0 0 1 0 144 a 45 45 0 0 1 0 -144"
                v-if="deals.percent[1]"
              />
              <text
                style="font-size: 1.75rem; font-family: 'Montserrat', sans-serif;"
                class="count"
                x="50%"
                y="52%"
                text-anchor="middle"
              >{{ deals.count[1] | number(0) }}</text>
              <text
                style="font-size: 1rem; font-family: 'Montserrat', sans-serif;"
                class="value"
                x="50%"
                y="52%"
                text-anchor="middle"
                dy="20"
                :fill="deals.colors[0]"
              >
                <tspan class="value">{{ deals.value[1] | currency }}</tspan>
              </text>
            </svg>
            <img v-else :src="pngSrc[deals.svgId]" width="165" height="165" :id="`${deals.svgId}-img`"/>
            <div
              class="percentage" v-b-tooltip.left="__('Porcentagem em relação aos negócios iniciados.')">
              <div v-if="deals.percentage_start">
                <span class="pr-28px">{{ getNumberWithDecimalPlaces(deals.percentage_start[0]) + "%" }}</span>
              </div>
            </div>
            <div
              class="stats text-right"
              :id="`${deals.svgId}-text`"
              v-b-tooltip.left="__('Em relação ao período anterior.')"
            >
              <div>
                <span class="pr-28px">{{ deals.count[1] - deals.count[0] | number(0) }}</span><span class="trend"><i :class="icon(deals.count[1] - deals.count[0])" /></span>
              </div>
              <div>
                <span class="pr-28px">{{ deals.value[1] - deals.value[0] | currency(0) }}</span><span class="trend"><i :class="icon(deals.value[1] - deals.value[0])" /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';


export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [require('../../mixins/deals-widget.js')],
  methods: {
    icon (trend = 0) {
      if (trend < 0) {
        return 'fa fa-angle-down color-salesflow-danger-hover';
      }

      return 'fa fa-angle-up color-salesflow-secondary';
    },

    getStroke (index) {
      return `url(#gradient-${index})`;
    },

    getNumberWithDecimalPlaces(num) {
      switch (true) {
        case (num === 0):
          return 0;
        case (num < 1):
          return num.toFixed(3);
        case (num >= 1):
          return num.toFixed(2);
      }
    },
  },
};
</script>
<style lang="scss">
  .percentage {
    position: absolute;
    bottom: 73px;
    right: 15px;
    z-index: 2;
  }
</style>
